document.addEventListener("DOMContentLoaded", async () => {
    const { initAnchorLink } = await import("../components/anchorlink.js");
    initAnchorLink(false);
});
